export const baseUrl = '/aros/';

export const routes = [
    {
        name: 'home' ,
        pattern: baseUrl + 'home',
    },
    {
        name: 'listetome',
        pattern: baseUrl + 'listetome',
    },
    {
        name: 'carte',
        pattern: baseUrl + 'carte',
    },
    {
        name: 'couverture',
        pattern: baseUrl + 'couverture',
    },
    {
        name: 'genese',
        pattern: baseUrl + 'genese',
    },
    {
        name: 'jdr',
        pattern: baseUrl + 'jdr',
    },
    {
        name: 'livraison',
        pattern: baseUrl + 'livraison',
    },
    {
        name: 'contact',
        pattern: baseUrl + 'contact',
    },
    {
        name: 'notFound',
        pattern: '/not-found'
    }
]    


// WEBPACK FOOTER //
// ./src/donnees/Routes.js